import { render } from "./offerDetail.vue?vue&type=template&id=50d4fb80&ts=true"
import script from "./offerDetail.vue?vue&type=script&lang=ts"
export * from "./offerDetail.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\CarpeDiem\\AntiSmoking\\Backend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__